module.exports = __webpack_public_path__ + "img/rotate-clockwise.fbd4665b.svg";